import React from "react";
import Loader from "../../../../../Component/Loader";

function FareRules({ flight, Rules, heading, headingReturn }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flex: 1,
        flexDirection: "column",
      }}
    >
      <h6 style={{ fontWeight: "bold", marginTop: 20 }}>
        {heading} - Fare Rules
      </h6>
      <div className="mb-0" style={{ fontSize: "0.8rem" }}>
        <ul>
          {flight.fare.adult.cancellationCharges.type === "REFUNDABLE" && (
            <li>🤑 This flight allows cancellation refund with conditions</li>
          )}
          {flight.fare.adult.ancillery.seat && (
            <li>💺 Seat Selection is available for this flight</li>
          )}
          {flight.fare.adult.ancillery.dateChange && (
            <li>📆 Date change is available for you on this flight</li>
          )}
          {flight.fare.adult.ancillery.meal && (
            <li>🌮 Inflight Meal is avaialble on this flight</li>
          )}
          <li>🧳 Total check-in baggage is 15Kg (1 unit)</li>
        </ul>
      </div>

      <h6 style={{ fontWeight: "bold", marginTop: 20 }}>
        {headingReturn} - Fare Rules
      </h6>
      <div className="mb-0" style={{ fontSize: "0.8rem" }}>
        <ul>
          {flight.fare.adult.cancellationCharges.type === "REFUNDABLE" && (
            <li>🤑 This flight allows cancellation refund with conditions</li>
          )}
          {flight.fare.adult.ancillery.seat && (
            <li>💺 Seat Selection is available for this flight</li>
          )}
          {flight.fare.adult.ancillery.dateChange && (
            <li>📆 Date change is available for you on this flight</li>
          )}
          {flight.fare.adult.ancillery.meal && (
            <li>🌮 Inflight Meal is avaialble on this flight</li>
          )}
          <li>🧳 Total check-in baggage is 15Kg (1 unit)</li>
        </ul>
      </div>

      {Rules && Rules?.fareRules ? (
        <div
          className="border-box mt-4 mb-4"
          style={{ background: "#FEF3CC", border: "none" }}
        >
          <h6 style={{ fontWeight: "bold" }}>Important Information</h6>
        </div>
      ) : (
        <Loader />
      )}

      {Object.keys(Rules.fareRules).map((code) => {
        let item = Rules.fareRules[code];
        return (
          <div>
            <div
              className="flex flex-horizontally mt4 mb2"
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                alignItems: "center",
                marginTop: 20,
              }}
            >
              <h6>{code} Cancellation Rules Per Pax</h6>
              {item?.refund && (
                <div
                  style={{
                    background: "black",
                    padding: "4px 6px",
                    color: "white",
                    borderRadius: 6,
                    fontSize: 10,
                  }}
                >
                  {item.refund}
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                fontSize: 14,
                padding: 5,
              }}
              className="flex bg-container w-100 horizontally border"
            >
              <div className="flex-1 pd1">
                <div>Time Frame / Type</div>
                <div className="text-small">
                  (From Scheduled Flight Departure)
                </div>
              </div>
              <div className="flex-1  pd1 border-left border-right">
                <div>Airline Charges</div>
                <div className="text-small">(Per Pax)</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                fontSize: 14,
                padding: 5,
              }}
              className="flex w-100 horizontally border"
            >
              <div className="flex-1 pd1">Airline Fees</div>
              <div className="flex-1  pd1 border-left border-right">
                {isNaN(
                  parseFloat(
                    item.cancellation?.airlineFees ||
                      item.dPlus?.airlineCharges ||
                      "0"
                  )
                )
                  ? item.cancellation?.airlineFees ||
                    item.dPlus?.airlineCharges ||
                    "0"
                  : parseFloat(
                      item.cancellation?.airlineFees ||
                        item.dPlus?.airlineCharges ||
                        "0"
                    ).toFixed(2)}
              </div>
            </div>
            {Object.keys(item.rules).map((xItem) => {
              return (
                <div
                  key={xItem}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    fontSize: 14,
                    padding: 5,
                  }}
                  className="flex w-100 horizontally border"
                >
                  <div className="flex-1 pd1">{xItem}</div>
                  <div className="flex-1  pd1 border-left border-right">
                    {isNaN(parseFloat(item.rules[xItem].policy))
                      ? item.rules[xItem].policy
                      : parseFloat(item.rules[xItem].policy).toFixed(2)}
                  </div>
                </div>
              );
            })}
            {/* <PlatformChargeDisclaimer disclaimer="⚠️ Airline Cancellation charges are indicative. Cleartrip will stop
      accepting cancellation requests 4 hours before departure of the flight.
      Additionally, Cleartrip's Platform fee will be levied as per the
      commercial agreement." /> */}
            <h6 className="mt4 mb2" style={{ marginTop: 16, marginBottom: 8 }}>
              Flight Change Rules Per Pax
            </h6>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                fontSize: 14,
                padding: 5,
              }}
              className="flex bg-container w-100 horizontally border"
            >
              <div className="flex-1 pd1">
                <div>Time Frame / Type</div>
                <div className="text-small">
                  (From Scheduled Flight Departure)
                </div>
              </div>
              <div className="flex-1  pd1 border-left border-right">
                <div>Airline Charges</div>
                <div className="text-small">(Per Pax)</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                fontSize: 14,
                padding: 5,
              }}
              className="flex w-100 horizontally border"
            >
              <div className="flex-1 pd1">Others</div>
              <div className="flex-1  pd1 border-left border-right">
                {isNaN(
                  parseFloat(
                    item.dateChange.airlineFees ||
                      item.dateChange.airlineCharges ||
                      "0"
                  )
                )
                  ? item.dateChange.airlineFees ||
                    item.dateChange.airlineCharges ||
                    "0"
                  : parseFloat(
                      item.dateChange.airlineFees ||
                        item.dateChange.airlineCharges ||
                        "0"
                    ).toFixed(2)}
              </div>
            </div>
            {/* <PlatformChargeDisclaimer disclaimer="⚠️ Flight change charges are indicative. Cleartrip will stop accepting
      change requests 4 hours before departure of the flight. Additionally,
      Cleartrip's Platform fee will be levied as per the commercial agreement." /> */}
          </div>
        );
      })}
    </div>
  );
}

export default FareRules;
